import {
  Component, ViewEncapsulation, AfterViewInit, ViewChild, ElementRef, Renderer2, Inject, OnInit, HostBinding,
  ComponentRef, ViewContainerRef, OnDestroy
} from "@angular/core";
import {Observable, AsyncSubject} from "rxjs";
import {DOCUMENT, Meta, Title} from "@angular/platform-browser";
import {ActivatedRoute, Router} from "@angular/router";
import {CostGuideUtils} from "../../../../common/utils/costguideutils";
import {TransferState} from "../../../modules/transfer-state/transfer-state";
import {LoopBackConfig} from "../../shared/sdk/lb.config";
import {BASE_URL, API_VERSION} from "../../shared/base.url";
import {FixrAPIApi} from "../../shared/sdk/services/custom/FixrAPI";
import {DynamicTypeBuilder, IHaveDynamicData} from "../../shared/type-builder/type.builder";
import {StringUtils} from "../../shared/services/stringutils";

@Component({
  templateUrl: 'cost-guide.component.html',
  styleUrls: [ 'cost-guide.component.scss' ],
  selector: 'costGuideComponent',
  encapsulation: ViewEncapsulation.None,
/*  animations: [ routeAnimation ],
  host: {
    '[@routeAnimation]': 'true',
    '[style.display]': "'block'",
    '[style.position]': "'absolute'",
    '[style.left]' : "'0'",
    '[style.right]' : "'0'"
  }, */
})

export class CostGuideComponent implements AfterViewInit, OnDestroy {

  public costGuideView: Observable<object>;
  protected zipcodeModificationFactorsView: Observable<object>;
  protected componentRef: ComponentRef<IHaveDynamicData>;

  @ViewChild('content', {read: ViewContainerRef}) public contentContainer: ViewContainerRef;

  protected costGuideData: object;
  protected cities: any;
  protected costGuideAsyncSubject: AsyncSubject<object> = new AsyncSubject();
  protected viewInitizalized: boolean = false;

  constructor(protected renderer: Renderer2,
              @Inject(DOCUMENT) protected  document: any,
              protected router: Router,
              protected route: ActivatedRoute,
              protected title: Title,
              protected stringUtils: StringUtils,
              protected meta: Meta,
              protected costGuideUtils: CostGuideUtils,
              protected cache: TransferState,
              protected fixrAPIApi: FixrAPIApi,
              protected typeBuilder: DynamicTypeBuilder,
              @Inject('isBrowser') protected isBrowser: boolean) {

    LoopBackConfig.setBaseURL(BASE_URL);
    LoopBackConfig.setApiVersion(API_VERSION);

    route.params.subscribe(params => {
      this.renderCostGuide('/costs/' + params['seoId']);
    });

  }

  ngAfterViewInit() {
    this.costGuideAsyncSubject.subscribe(costGuideData => {
      this.renderData(costGuideData);
    });
    this.viewInitizalized = true;
  }

  public showCostGuideForm() {
    let tasks = this.costGuideData['fixrTasks'].split(',');
    if(this.costGuideData['group'] == 4) {
      this.router.navigate(['/insurance-form/' + tasks[0].trim()]);
    }
    else {
      this.router.navigate(['/remodeling-form/' + tasks[0].trim()]);
    }
  }

  protected renderData(costGuideData) {

    if (this.componentRef) {
      this.componentRef.destroy();
    }

    let content = this.stringUtils.unescapeTransferStateCacheData(costGuideData['content']);

    this.typeBuilder.createComponent(content, this.contentContainer)
      .then(componentRef => {
        this.componentRef = componentRef;
      });

    this.title.setTitle(costGuideData['pageMetaTitle']);
    this.meta.updateTag({ name: 'description', content: costGuideData['pageMetaDescription']});

    //change aspect of cost guide on mobile:
    if(this.isBrowser && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent) ) {
      $("#costSummary").insertBefore(".cost-guide-container .content");
    }

    let citiesCacheKey = 'zipcodeModificationFactors-' + costGuideData['id'];
    let zipcodeModificationFactorsFromCache = this.cache.get(citiesCacheKey);
    if(zipcodeModificationFactorsFromCache != null) {
      this.zipcodeModificationFactorsView = Observable.of(zipcodeModificationFactorsFromCache);
      this.cities = zipcodeModificationFactorsFromCache;
    }
    else {
      this.zipcodeModificationFactorsView = this.costGuideUtils.loadZipcodeModificationFactors(costGuideData);
      this.zipcodeModificationFactorsView.subscribe(data => {
        this.cache.set(citiesCacheKey, data);
        this.cities = data;
      });
    }

    //cache task questionnaire:
    let taskIds = costGuideData['fixrTasks'].split(',');
    var questionnaireObject = this.cache.get(taskIds[0].trim());
    if(questionnaireObject == null) {
      this.fixrAPIApi.getJobQuestionnaires(taskIds[0].trim()).
      subscribe(questionnaire => {
        let questionnaireObject = JSON.parse(questionnaire[0]);
        this.cache.set(taskIds[0].trim(), questionnaireObject);
      });
    }

  }

  protected renderCostGuide(url: string) {

    let costGuideViewFromCache = this.cache.get(url);
    if(costGuideViewFromCache != null) {
      this.costGuideView = Observable.of(costGuideViewFromCache);
      this.costGuideData = costGuideViewFromCache;
    }
    else {
      this.costGuideView = this.costGuideUtils.loadCostGuide(url);

      //avoid call twice from client by storing the data in the cache
      this.costGuideView.subscribe(data => {
        this.cache.set(url, data);
        this.costGuideData = data;
      });

    }

    if(!this.viewInitizalized) {
      //use an async subject if the view has not been initialized
      this.costGuideView.subscribe(this.costGuideAsyncSubject);
    }
    else {
      this.costGuideView.subscribe(costGuideData => {
        this.renderData(costGuideData);
      });
    }

  }

  public ngOnDestroy(){
    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/cost-guide/cost-guide-page/cost-guide.component.ts